import apiService from "services/api";
import { FOLDER_PAGINATION_SEARCH, HOST_URL } from "../constants";

export default {
  projects: {
    list: async (payload) => {
      const { offset, limit, sortKey, sortDirection, owner, filters } = payload;
      const _filters = {
        state: filters?.state || [],
      };
      const searchParams = new URLSearchParams("");
      searchParams.append("offset", offset);
      searchParams.append("limit", limit);
      searchParams.append("sort", sortKey);
      searchParams.append("direction", sortDirection);
      if (owner) {
        searchParams.append("owner", owner);
      }
      Object.keys(_filters).forEach((key) => {
        if (_filters[key].length > 0) {
          _filters[key].forEach((f) => {
            searchParams.append(key, f);
          });
        }
      });
      return apiService.get(`${HOST_URL}/api/projects?${searchParams}`);
    },
    get: async (payload) => {
      const { projectId } = payload;
      return apiService.get(`${HOST_URL}/api/projects/${projectId}`);
    },
    getByUrl: async (payload) => {
      const { url } = payload;
      return apiService.get(
        `${HOST_URL}/api/projects/by-url?project_url=${url}`
      );
    },
    create: async (payload) => {
      const { owner, name } = payload;
      return apiService.post(`${HOST_URL}/api/projects`, {
        body: JSON.stringify({ owner, name, models: {} }),
      });
    },
    update: async (payload) => {
      const { projectId, models } = payload;
      return apiService.put(`${HOST_URL}/api/projects/${projectId}`, {
        body: JSON.stringify({ models }),
      });
    },
    rename: async (payload) => {
      const { projectId, name } = payload;
      return apiService.patch(`${HOST_URL}/api/projects/${projectId}`, {
        body: JSON.stringify({ name }),
      });
    },
    delete: async (payload) => {
      const { projectId, permanent = false } = payload;
      return apiService.delete(
        `${HOST_URL}/api/projects/${projectId}?hard_delete=${permanent}`
      );
    },
    stats: async (payload) => {
      const { projectIds } = payload;
      return apiService.post(`${HOST_URL}/api/stats/projects`, {
        body: JSON.stringify({ project_ids: projectIds }),
      });
    },
    download: async (payload) => {
      const { projectId, starred } = payload;
      return apiService.get(
        `${HOST_URL}/api/projects/${projectId}/export?starred_only=${starred}`
      );
    },
    search: async (payload) => {
      const { search: _search } = payload;
      const search = _search ? encodeURIComponent(_search) : undefined;
      return apiService.get(`${HOST_URL}/api/projects/search?search=${search}`);
    },
  },
  folders: {
    list: async (payload) => {
      const { projectId, offset, limit, sortKey, sortDirection } = payload;
      return apiService.get(
        `${HOST_URL}/api/folders?project_id=${projectId}&offset=${offset}&limit=${limit}&sort=${sortKey}&direction=${sortDirection}`
      );
    },
    create: async (payload) => {
      const folder = payload;
      return apiService.post(`${HOST_URL}/api/folders`, {
        body: JSON.stringify({
          project_id: folder.projectId,
          name: folder.name,
          parent_id: folder.parentId,
        }),
      });
    },
    update: async (payload) => {
      const { folderId, name } = payload;
      return apiService.patch(`${HOST_URL}/api/folders/${folderId}`, {
        body: JSON.stringify({ name }),
      });
    },
    delete: async (payload) => {
      const { folderId, permanent } = payload;
      return apiService.delete(
        `${HOST_URL}/api/folders/${folderId}?hard_delete=${permanent}`
      );
    },
    stats: async (payload) => {
      const { folderIds } = payload;
      return apiService.post(`${HOST_URL}/api/stats/folders`, {
        body: JSON.stringify({ folder_ids: folderIds }),
      });
    },
    search: async (payload) => {
      const { projectId, search: _search, offset } = payload;
      const search = _search ? encodeURIComponent(_search) : undefined;
      return apiService.get(
        `${HOST_URL}/api/folders/search?project_id=${projectId}&search=${search}&offset=${offset}&limit=${FOLDER_PAGINATION_SEARCH}`
      );
    },
    download: async (payload) => {
      const { folderId, starred } = payload;
      return apiService.get(
        `${HOST_URL}/api/folders/${folderId}/export?starred_only=${starred}`
      );
    },
  },
  recordings: {
    originalsList: async (payload) => {
      const { folderId, offset, limit, sortKey, sortDirection } = payload;
      return apiService.get(
        `${HOST_URL}/api/recordings/originals?folder_id=${folderId}&offset=${offset}&limit=${limit}&sort=${sortKey}&direction=${sortDirection}`
      );
    },
    conversionsList: async (payload) => {
      const { originalId, offset, limit } = payload;
      return apiService.get(
        `${HOST_URL}/api/recordings/conversions?original_id=${originalId}&offset=${offset}&limit=${limit}&direction=desc`
      );
    },
    list: async (payload) => {
      const { folderId } = payload;
      return apiService.get(`${HOST_URL}/api/recordings?folder_id=${folderId}`);
    },
    create: async (payload) => {
      const { data, folderId, projectId, microphone } = payload;
      let fd = new FormData();
      fd.append("data", data);
      fd.append("project_id", projectId);
      fd.append("parent_folder_id", folderId);
      fd.append("microphone", microphone);
      return apiService.post(`${HOST_URL}/api/recordings`, {
        headers: {
          "content-type": undefined,
        },
        body: fd,
      });
    },
    createTTS: async (payload) => {
      const { projectId, folderId, text, voiceId, language } = payload;
      return apiService.post(`${HOST_URL}/api/v2/recordings/tts`, {
        body: JSON.stringify({
          project_id: projectId,
          parent_folder_id: folderId,
          text: text,
          text_language: language,
          voice_id: voiceId,
          // label
        }),
      });
    },
    update: async (payload) => {
      const { recordingId, data } = payload;
      return apiService.patch(`${HOST_URL}/api/recordings/${recordingId}`, {
        body: JSON.stringify(data),
      });
    },
    delete: async (payload) => {
      const { recordingId, permanent } = payload;
      return apiService.delete(
        `${HOST_URL}/api/recordings/${recordingId}?hard_delete=${permanent}`
      );
    },
    order: async (payload) => {
      const { originalId, conversions, calibrationId, useCalibration } =
        payload;
      return apiService.post(`${HOST_URL}/api/v2/orders`, {
        body: JSON.stringify({
          original_id: originalId,
          conversions,
          calibration_id: calibrationId,
          use_calibration: useCalibration,
        }),
      });
    },
    redo: async (payload) => {
      const { recordingId } = payload;
      return apiService.post(`${HOST_URL}/api/v2/orders/retry/${recordingId}`);
    },
    export: async (payload) => {
      const { originalId, starred } = payload;
      let url = `${HOST_URL}/api/recordings/export/?original_id=${originalId}`;
      if (starred) {
        url = `${url}&starred_only=true`;
      }
      return apiService.get(url);
    },
    get: async (payload) => {
      const { originalId } = payload;
      return apiService.get(`${HOST_URL}/api/recordings/${originalId}`);
    },
    reportConversionIssue: async (payload) => {
      const { conversionId, description } = payload;
      return apiService.post(
        `${HOST_URL}/api/recordings/${conversionId}/conversion-issue`,
        {
          body: JSON.stringify({ description: description }),
        }
      );
    },
    conversionCount: async (payload) => {
      const { originalId, voicesIds } = payload;
      return apiService.post(`${HOST_URL}/api/recordings/conversion-count`, {
        body: JSON.stringify({
          original_id: originalId,
          voice_ids: voicesIds,
        }),
      });
    },
  },
  notes: {
    list: async (payload) => {
      const { folderId } = payload;
      return apiService.get(`${HOST_URL}/api/notes?folder_id=${folderId}`);
    },
    create: async (payload) => {
      const { recordingId, text } = payload;
      return apiService.post(`${HOST_URL}/api/notes`, {
        body: JSON.stringify({ recording_id: recordingId, text: text }),
      });
    },
    update: async (payload) => {
      const { recordingId, text } = payload;
      return apiService.put(`${HOST_URL}/api/notes`, {
        body: JSON.stringify({ recording_id: recordingId, text: text }),
      });
    },
    delete: async (payload) => {
      const { recordingId } = payload;
      return apiService.delete(`${HOST_URL}/api/notes`, {
        body: JSON.stringify({ recording_id: recordingId }),
      });
    },
  },
  other: {
    ttsVoices: async () => apiService.get(`${HOST_URL}/api/tts-voices`),
    stats: async () => apiService.get(`${HOST_URL}/api/stats`),
    allUsersStats: async (payload) => {
      const { limit, offset, sort, direction, owner_ids } = payload;
      return apiService.post(`${HOST_URL}/api/stats/users`, {
        body: JSON.stringify({ limit, offset, sort, direction, owner_ids }),
      });
    },
  },
};
